
<template>
  <p class="com-text" v-html="dataInfo.value" @click.capture="handleClick"></p>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
import { executeProtocol, executeProtocolOutApp } from '_lib/utils'
export default {
  mixins: [CptMixin],
  methods: {
    handleClick (e) {
      e.preventDefault()
      switch (e.target.tagName) {
        case 'A': {
          if (e.target.href == 'heybox://open_subject') {
            let protocol = {
              protocol_type: 'openBBSTag',
              tag: e.target.innerText.replace(/#/g, '')
            }
            switch (this.articleInfo.source) {
              case 'share': {
                executeProtocolOutApp(protocol)
                break
              }
              case 'post': {
                break
              }
            }
          }
          break
        }
      }
    }
  }
}
</script>

<style lang="less">
.com-text {
  @import "../../../assets/css/inner-html.less"; 
  margin-top: 12px;
  font-size: 16px;
  line-height: 25px;
  color: rgb(20, 25, 30);
  word-break: break-all;
  word-wrap: break-word;
}

</style>